import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { ErrorPageLayoutComponent } from '@core/components/error-page-layout/error-page-layout.component';

@Component({
  selector: 'app-api-down',
  imports: [TranslatePipe, ErrorPageLayoutComponent],
  templateUrl: './api-down.component.html',
  styles: ``
})
export class ApiDownComponent {}
